<template>
  <div>
    <modal-form modal-id="add-client">
      <div slot="title">Add Client</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg-4">Name</div>
            <div class="col-lg-8"><input type="text" name="" v-model="clientName" class="form-control"></div>
          </div>
          <div class="row">
            <div class="col-lg-12 m-t-md">
              <button class="btn btn-sm btn-primary pull-right" @click="saveClient">Save</button>
            </div>
          </div>
        </div>
      </div>
    </modal-form>
    <modal-form modal-id="add-order">
      <div slot="title">Add Order</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg-4">Name</div>
            <div class="col-lg-8"><input type="text" name="" v-model="order['name']" class="form-control"></div>
            <div class="col-lg-4">Client</div>
            <div class="col-lg-8">
              <v-select v-model="order['client']" :options="this.f.clients" label="name" :reduce="c => c.id"></v-select>
            </div>
            <div class="col-lg-4">Description</div>
            <div class="col-lg-8"><textarea v-model.number="order['description']" class="form-control"></textarea></div>
            <div class="col-lg-4">Size</div>
            <div class="col-lg-8"><input type="number" name="" v-model.number="order['size']" class="form-control"></div>
          </div>
          <div class="row">
            <div class="col-lg-12 m-t-md">
              <button class="btn btn-sm btn-primary pull-right" @click="saveOrder">Save</button>
            </div>
          </div>
        </div>
      </div>
    </modal-form>
    <modal-form modal-id="add-group">
      <div slot="title">Add Group</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg-4">Name</div>
            <div class="col-lg-8"><input type="text" name="" v-model="group['name']" class="form-control"></div>
            <div class="col-lg-4">Client</div>
            <div class="col-lg-8">
              <v-select v-model="group['client']" :options="this.f.clients" label="name" :reduce="c => c.id"></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 m-t-md">
              <button class="btn btn-sm btn-primary pull-right" @click="saveGroup">Save</button>
            </div>
          </div>
        </div>
      </div>
    </modal-form>
    <div class="row">
      <div class="col-lg-2">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <th>Clients <button class="btn btn-primary btn-xs pull-right" data-toggle="modal" data-target="#add-client">Add new</button></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="client in f.clients" :key="client.id">
            <td>{{ client.name }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-lg-4">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <th colspan="2">Groups <button class="btn btn-primary btn-xs pull-right" data-toggle="modal" data-target="#add-group">Add new</button></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="group in f.groups" :key="group.id">
            <td>{{ group.client.name }}</td>
            <td>{{ group.name }}</td>
          </tr>
          </tbody>
        </table>
        <table class="table table-striped table-bordered table-hover" v-if="false">
          <thead>
          <tr>
            <th colspan="2">Orders <button class="btn btn-primary btn-xs pull-right" data-toggle="modal" data-target="#add-order">Add new</button></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="order in f.orders" :key="order.id">
            <td>{{ order.name }}</td>
            <td>{{ order.client.name }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-lg-3">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <th colspan="2">Registrars</th>
          </tr>
          </thead>
          <tbody v-for="rego in f.registrars" :key="rego.id">
          <tr>
            <td colspan="2">
              {{ rego.name }}
              <a :href="rego.login.url" target="_blank"><i class="fa fa-link pull-right hover-icon"></i></a>
            </td>
          </tr>
          <tr>
            <td>
              {{ shorten(rego.login.user, 15) || '?' }}
              <a @click="copyToClipboard(rego.login.user)"><i class="fa fa-copy pull-right" title="Copy"></i></a>
            </td>
            <td>
              {{ shorten(rego.login.pass, 15) || '?' }}
              <a @click="copyToClipboard(rego.login.pass)"><i class="fa fa-copy pull-right"></i></a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-lg-3">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <th colspan="2">Hosts</th>
          </tr>
          </thead>
          <tbody v-for="host in f.hosts" :key="host.id">
          <tr>
            <td colspan="2">
              {{ host.name }}
              <a :href="host.login.url" target="_blank"><i class="fa fa-link pull-right hover-icon"></i></a>
            </td>
          </tr>
          <tr>
            <td>
              {{ shorten(host.login.user) || '?' }}
              <a @click="copyToClipboard(host.login.user)"><i class="fa fa-copy pull-right" title="Copy"></i></a>
            </td>
            <td>
              {{ shorten(host.login.pass) || '?' }}
              <a @click="copyToClipboard(host.login.pass)"><i class="fa fa-copy pull-right"></i></a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Browser, Values } from '../../../../mixins/helperMixin'
import Form from '../../../Helpers/Modal/Form'
import axios from 'axios'

export default {
  data () {
    return {
      clientName: '',
      order: {},
      group: {}
    }
  },
  components: {
    modalForm: Form
  },
  mounted () {
    document.title = 'Data :: PBN360 by Aphex Media'
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  mixins: [Browser, Values],
  methods: {
    saveClient () {
      axios.post('/pbn/client', {
        name: this.clientName
      })
        .then(r => {
          this.$store.dispatch('loadFilters')
          $('#add-client').modal('hide')
          this.clientName = ''
        }).catch(e => {
          this.$toastr.error(e, 'Error')
        })
    },
    saveOrder () {
      if (!this.order.name) {
        this.$toastr.error('Please add order name')
        return
      }
      if (!this.order.client) {
        this.$toastr.error('Please select client')
        return
      }

      axios.post('/pbn/order', {
        name: this.order.name,
        client: this.order.client.id,
        size: this.order.size || null,
        description: this.order.description || ''
      }).then(r => {
        this.$store.dispatch('loadFilters')
        $('#add-order').modal('hide')
        this.order = {}
      }).catch(e => {
        this.$toastr.error(e, 'Error')
      })
    },
    saveGroup () {
      if (!this.group.name) {
        this.$toastr.error('Please add group name')
        return
      }
      if (!this.group.client) {
        this.$toastr.error('Please select client')
        return
      }

      axios.post('/pbn/group', {
        name: this.group.name,
        client: this.group.client.id
      }).then(r => {
        this.$store.dispatch('loadFilters')
        $('#add-group').modal('hide')
        this.group = {}
      }).catch(e => {
        this.$toastr.error(e, 'Error')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Overview/Data.vue